import { Domain } from "./domain";
import { EventBase } from "./eventBase";
const CurriculumEvent = {
    SESSION_TIMELINE_SEGMENT_TOGGLED: "Session Timeline Segment Toggled",
    SESSION_TIMELINE_SEGMENT_REORDERED: "Session Timeline Segment Reordered",
    SESSION_TIMELINE_SEGMENT_EDITED: "Session Timeline Segment Edited",
};
class CurriculumEventBase extends EventBase {
    constructor(payload) {
        super({
            context: payload,
            contentId: payload.curriculumId,
        });
    }
    get domain() {
        return Domain.CURRICULUM;
    }
}
export class SessionTimelineSegmentToggled extends CurriculumEventBase {
    constructor(payload) {
        super(payload);
    }
    get eventName() {
        return CurriculumEvent.SESSION_TIMELINE_SEGMENT_TOGGLED;
    }
}
export class SessionTimelineSegmentReordered extends CurriculumEventBase {
    constructor(payload) {
        super(payload);
    }
    get eventName() {
        return CurriculumEvent.SESSION_TIMELINE_SEGMENT_REORDERED;
    }
}
export class SessionTimelineSegmentEdited extends CurriculumEventBase {
    constructor(payload) {
        super(payload);
    }
    get eventName() {
        return CurriculumEvent.SESSION_TIMELINE_SEGMENT_EDITED;
    }
}
//# sourceMappingURL=curriculumEvents.js.map